import { Signer } from './signer';
import { Keccak256Hasher } from '../hashers';
import { Platform } from '../providers';
// import {
//   ecsign,
//   bufferToHex,
//   toBuffer,
//   setLengthLeft,
//   hashPersonalMessage,
// } from 'ethereumjs-util';
// const a = '2A77A5C9DBA59D6F8B7A';
// const b = '2737A8A6D8E511CDC9439';
// const c = 'C97E919959D02502F8BCB50';
// function sendSync({ params }) {
//   const msg = hashPersonalMessage(toBuffer(params[0]))
//     .toString('hex')
//     .replace('0x', '');
//   const { r, s, v } = ecsign(
//     new Buffer(msg, 'hex'),
//     new Buffer(`${a}${b}${c}`, 'hex')
//   );
//   const hexsig = bufferToHex(
//     Buffer.concat([
//       setLengthLeft(r, 32),
//       setLengthLeft(s, 32),
//       toBuffer(v - 27),
//     ])
//   );
//   return hexsig;
// }
export class EthSigner extends Signer {
    constructor(from) {
        super(new Keccak256Hasher());
        this.from = from;
        this.currentPlatform = Platform.eth;
    }
    signMessages(messages) {
        return new Promise((resolve, reject) => {
            const from = this.from;
            const handleResult = (result) => {
                let v = Number.parseInt(result.slice(-2), 16);
                if (v >= 27)
                    v -= 27;
                result =
                    '0x' +
                        this.currentPlatform.toString(16).padStart(2, '0') +
                        result.slice(2, -2) +
                        v.toString(16).padStart(2, '0');
                return result;
            };
            if (typeof window.ethereum !== 'undefined') {
                window.ethereum
                    .request({
                    method: 'personal_sign',
                    params: [from, messages[0].message],
                })
                    .then((result) => {
                    resolve([handleResult(result)]);
                });
            }
            else if (!!window.web3) {
                window.web3.currentProvider.sendAsync({
                    method: 'personal_sign',
                    params: [messages[0].message, from],
                    from,
                }, (err, result) => {
                    if (err) {
                        reject(err);
                    }
                    if (result.error) {
                        reject(result.error);
                    }
                    resolve([handleResult(result.result)]);
                });
            }
            else {
                reject(new Error('window.ethereum/window.web3 is undefined, Ethereum environment is required.'));
            }
            // const from = this.from;
            // const params = [messages[0].message, from];
            // const method = 'personal_sign';
            // window.web3.currentProvider.sendAsync(
            //   { method, params, from },
            //   (err, result) => {
            //     if (err) {
            //       reject(err);
            //     }
            //     if (result.error) {
            //       reject(result.error);
            //     }
            //     result = result.result;
            //     let v = Number.parseInt(result.slice(-2), 16);
            //     if (v >= 27) v -= 27;
            //     result =
            //       '0x' +
            //       this.currentPlatform.toString(16).padStart(2, '0') +
            //       result.slice(2, -2) +
            //       v.toString(16).padStart(2, '0');
            //     resolve([result]);
            //   }
            // );
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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